export default "__VITE_ASSET__CtVrvzrE__"